import { css } from "@emotion/core"

export const link = css`
  a {
    color: #945a47;
    text-decoration: none;
  }
  a:hover {
    text-decoration: underline;
  }
`
export const navLink = css`
  a {
    color: #808080;
    text-decoration: none;
  }
  a:hover {
    font-weight: bold;
    color: #1f1714;
  }
`
